"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildStreamType = exports.isTokenLock = exports.isPayment = exports.calculateUnlockedAmount = void 0;
var bn_js_1 = __importDefault(require("bn.js"));
var types_1 = require("./types");
var calculateUnlockedAmount = function (_a) {
    var depositedAmount = _a.depositedAmount, cliff = _a.cliff, cliffAmount = _a.cliffAmount, end = _a.end, currentTimestamp = _a.currentTimestamp, lastRateChangeTime = _a.lastRateChangeTime, period = _a.period, amountPerPeriod = _a.amountPerPeriod, fundsUnlockedAtLastRateChange = _a.fundsUnlockedAtLastRateChange;
    var deposited = depositedAmount;
    if (currentTimestamp < cliff)
        return new bn_js_1.default(0);
    if (currentTimestamp > end)
        return deposited;
    var savedUnlockedFunds = lastRateChangeTime === 0 ? cliffAmount : fundsUnlockedAtLastRateChange;
    var savedUnlockedFundsTime = lastRateChangeTime === 0 ? cliff : lastRateChangeTime;
    var streamed = new bn_js_1.default(Math.floor((currentTimestamp - savedUnlockedFundsTime) / period))
        .mul(amountPerPeriod)
        .add(savedUnlockedFunds);
    return streamed.lt(deposited) ? streamed : deposited;
};
exports.calculateUnlockedAmount = calculateUnlockedAmount;
var isPayment = function (streamData) {
    return streamData.canTopup;
};
exports.isPayment = isPayment;
var isTokenLock = function (streamData) {
    return (!streamData.canTopup && streamData.cliffAmount.gte(streamData.depositedAmount.sub(new bn_js_1.default("1"))));
};
exports.isTokenLock = isTokenLock;
var buildStreamType = function (streamData) {
    if ((0, exports.isPayment)(streamData)) {
        return types_1.StreamType.Payment;
    }
    if ((0, exports.isTokenLock)(streamData)) {
        return types_1.StreamType.Lock;
    }
    return types_1.StreamType.Vesting;
};
exports.buildStreamType = buildStreamType;
